import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { IoIosCart } from "react-icons/io";

import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    margin: "0 .5rem"
  },
  media: {
    height: 0,
    paddingTop: '90.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

function AddCard({ data, addToCart, addToWish }) {
  const classes = useStyles();
  // const [expanded, setExpanded] = React.useState(false);
  // console.log(props)

  // const handleExpandClick = () => {
  //   setExpanded(!expanded);
  // };

  return (
    <Card className={classes.root}>
      <CardMedia
        className="card-media"
        image={data.image}
        title="Paella dish"
      />
      <CardContent className="card-title">
        <Typography variant="body2" color="textSecondary" component="p">
          {data.title}
        </Typography>
      </CardContent>
      <CardActions className="card-actions" disableSpacing>

        <IconButton className="action-icon-container scale" aria-label="add to favorites">
          <FavoriteIcon onClick={() => addToWish(data)} className="action-icon action-icon-heart" />
        </IconButton>

        <IconButton onClick={() => addToCart(data)} className="action-icon-container scale" aria-label="share">
          <IoIosCart className="action-icon action-icon-cart"/>
        </IconButton>

        <span className="price">{data.price}</span>
      </CardActions>
    </Card>
  );
}


const matchStateToProps = (state) => {
  return {
    basket: state.basket,
    wishlist: state.wishlist
  }
}

const matchDispatchToProps = (dispatch) => {
  return{
      addToCart: (item) => dispatch({ type: "ADD_TO_CART", item }),
      addToWish: (item) => dispatch({ type: "ADD_TO_WISH", item })
  }
}

export default connect(matchStateToProps, matchDispatchToProps)(AddCard);